import { render, staticRenderFns } from "./ConcludeEventDialog.vue?vue&type=template&id=4965c0ab&scoped=true"
import script from "./ConcludeEventDialog.vue?vue&type=script&lang=ts"
export * from "./ConcludeEventDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConcludeEventDialog.vue?vue&type=style&index=0&id=4965c0ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965c0ab",
  null
  
)

export default component.exports